const navToggleHandler = (slidingMenu: HTMLElement, open: boolean) => (event: Event) => {
    event.preventDefault();
    if (event.target !== null) {
        open === true ? slidingMenu.classList.remove('hidden') : slidingMenu.classList.add('hidden');
        open === true ? document.body.classList.add('overflow-hidden') : document.body.classList.remove('overflow-hidden');
    }
};

export const TopMenuClient = (): void => {
    const slidingMenu: null | HTMLElement = document.querySelector('.TopSlidingMenu');
    const openToggle: null | HTMLButtonElement = document.querySelector('.TopMenuToggle');
    const closeToggle: null | HTMLElement = document.querySelector('.SlidingMenuClose');
    const slidingMenuBg: null | HTMLElement = document.querySelector('.TopSlidingMenuBg');

    if (openToggle !== null && slidingMenu !== null && closeToggle !== null && slidingMenuBg !== null) {
        openToggle.addEventListener('click', navToggleHandler(slidingMenu, true));
        openToggle.addEventListener('touchend', navToggleHandler(slidingMenu, true));
        closeToggle.addEventListener('click', navToggleHandler(slidingMenu, false));
        closeToggle.addEventListener('touchend', navToggleHandler(slidingMenu, false));
        slidingMenuBg.addEventListener('click', navToggleHandler(slidingMenu, false));
    }
};
